import { useState, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  Page,
  Msg,
  LoadMore,
  Toast,
  Panel,
  PanelBody,
  MediaBox
} from 'react-weui';
import PropTypes from 'prop-types';
import TopNav from 'components/topNav.jsx';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import * as MobileActions from 'actions/index.ts';
import CommonFns from 'functions/common.ts';
import useList from 'hooks/useList';

function PricingProcessList(props) {
  const Config = {
    purchase: {
      title: '工序核价单列表',
      apiPath: '/price/order/getPageList',
      prcOrderType: 2,
      detailLink: '/mp/purchase/pricing/process/detail',
      orderProperty: 'createTime',
      //枚举列表
      arrEnumField: [
        {
          mainKey: 'B02_Price_Order_Status',
          subKey: 'status',
          value: 'statusName'
        },
        {
          mainKey: 'B02_Order_Sync_Status',
          subKey: 'syncStatus',
          value: 'syncStatusName'
        }
      ],
      companyNameKey: 'innerVendorName',
      tabs: ['全部', '待审核'],
      tabConfig: [
        undefined, //全部
        [1] //待审核
      ]
    }
  };
  const config = Config[props.type];
  const {
    companyCode,
    searchKey,
    inited,
    error,
    dataError,
    updateTs,
    currentTab,
    total,
    showLoading,
    list,
    count,
    setCount,
    handleTab,
    handleChange,
    handleClear,
    handleReset,
    self
  } = useList(props, config);

  const [checkByFlag, setCheckByFlag] = useState(false);

  //初始化默认企业
  useEffect(() => {
    self.init();
  }, [self]);

  //companyCode改变时执行
  useEffect(() => {
    self.getCount();
    //采购方
    if (self.isPurchase) {
      //todo
    }
  }, [companyCode, self]);

  //根据依赖多次执行
  useEffect(() => {
    self.search();
  }, [searchKey, companyCode, currentTab, checkByFlag, self]);

  //扩展搜索参数
  self.beforeSearch = async function () {
    if (self.isPurchase) {
      self.searchQueries = {
        checkByFlag: currentTab === 0 ? undefined : checkByFlag ? 1 : 0,
        status: config.tabConfig[currentTab],
        prcOrderType: config.prcOrderType
      };
    }
  };

  //仅显示本人审核
  function handleCheckByFlag(event) {
    setCheckByFlag(event.target.checked);
    handleReset();
  }

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  return (
    <Page
      transition={false}
      ptr={false}
      onLoadMore={(resolveLoading, finish) => {
        self.pageResolveLoading = resolveLoading;
        if (list.length >= total) {
          finish();
        } else {
          self.search();
        }
      }}
      className="v2"
    >
      <TopNav
        inited={inited}
        onSubmit={handleChange}
        onCancel={handleClear}
        onClear={handleClear}
        defaultValue={searchKey}
        placeholder={config.searchBarPlaceholder}
      />
      <Panel>
        {dataError !== null ? (
          <Msg {...dataError} />
        ) : (
          <span>
            <div className="m-tab-container">
              <ul className="m-flex-box">
                {config.tabs.map((item, index) => (
                  <li
                    key={index}
                    onClick={() => {
                      handleTab(index);
                    }}
                    className={
                      currentTab === index ? 'm-flex-item curr' : 'm-flex-item'
                    }
                  >
                    <span className="name">{item}</span>
                    {count[index] && (
                      <sup className="u-num">{count[index]}</sup>
                    )}
                  </li>
                ))}
              </ul>
              {self.isPurchase && currentTab === 1 && (
                <FormControlLabel
                  control={
                    <Switch
                      checked={checkByFlag}
                      onChange={handleCheckByFlag}
                      value="checkedA"
                      color="primary"
                    />
                  }
                  labelPlacement="start"
                  label="仅显示本人审核"
                />
              )}
            </div>
            <div className="list-total">{total}</div>
            <div className="m-details-item">
              <div className="details-item-content">
                {updateTs > 0 &&
                  list.map((item, index) => (
                    <Link
                      to={`${config.detailLink}/${companyCode}/${item.prcXkNo}`}
                      key={index}
                      className="content-line line-list-item"
                    >
                      <div className="line-list-item-title">
                        <span>{item.prcErpNo}</span>
                        <div className="more">
                          <span
                            className={
                              'u-sign ' +
                              CommonFns.getStatusClass('pricing', item.status)
                            }
                          >
                            {item.statusName}
                          </span>
                        </div>
                      </div>
                      <ul className={'field-list'}>
                        <li>
                          <label>供应商</label>
                          <div>
                            {item.innerVendorName}({item.innerVendorCode})
                          </div>
                        </li>
                        <li>
                          <label>核价人</label>
                          <div>{item.createName}</div>
                        </li>
                        <li>
                          <label>备注</label>
                          <div>{item.remark}</div>
                        </li>
                        <li>
                          <label>同步状态</label>
                          <div>
                            <span
                              className={
                                'u-sign ' +
                                CommonFns.getStatusClass(
                                  'sync',
                                  item.syncStatus
                                )
                              }
                            >
                              {item.syncStatusName}
                            </span>
                          </div>
                        </li>
                      </ul>
                    </Link>
                  ))}
                {!showLoading && list.length === 0 && (
                  <LoadMore showLine> 暂无数据</LoadMore>
                )}
              </div>
            </div>
          </span>
        )}
      </Panel>
      <Toast icon="loading" show={showLoading}>
        数据加载中...
      </Toast>
    </Page>
  );
}

PricingProcessList.propTypes = {
  actions: PropTypes.object.isRequired
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(mapDispatchToProps)(PricingProcessList);
